import { render, staticRenderFns } from "./stage-indicator.vue?vue&type=template&id=12ba2eec&"
import script from "./stage-indicator.vue?vue&type=script&lang=js&"
export * from "./stage-indicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports